import React from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'components/Modal';
import { Step } from 'components/SteppedModal';
import { YOUTUBE_VERIFICATION_LINK } from 'constants/social';
import { useSocialShareModal } from 'containers/SocialShareModal/SocialShareModalContext';
import { onYouTubeAccountVerificationCheck } from 'redux/modules/mixpanel';
import { Dispatch } from 'redux/types';
import { YouTubeSocialShareStep } from '../../types';
import YouTubeElegibleAccountStep from './YouTubeElegibleAccountStep';

export default function useYouTubeElegibleAccountStep(): Step<
  YouTubeSocialShareStep
> {
  const { goToStep } = useSocialShareModal();

  const dispatch = useDispatch<Dispatch>();

  const handleVerifyAccount = React.useCallback(() => {
    goToStep('verification');

    dispatch(
      onYouTubeAccountVerificationCheck({
        source: 'DownloadPage',
        status: 'AwaitingVerification',
      }),
    );
  }, [dispatch, goToStep]);

  return {
    id: 'elegible-account',
    component: <YouTubeElegibleAccountStep />,
    fluidFooterButtons: true,
    renderFooterButtons: () => [
      <Modal.FooterButton
        size="large"
        theme="submit"
        target="_blank"
        rel="noreferrer noopener"
        href={YOUTUBE_VERIFICATION_LINK}
        onClick={handleVerifyAccount}
      >
        verify your account
      </Modal.FooterButton>,
    ],
  };
}
